module.exports = __webpack_public_path__ + "img/AnnotatedTopBar.60d59029.jpg";